import React, { useEffect, useRef, useState } from "react";
import { cqAPI, getBid, loadPatients, getUserForPatient, loadProfiles, getProviderForProfile, getIfGroupedByReplyStatus } from "../../lib/Auth";
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "moment";
const _ = require("lodash");
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import {
  Box,
  Flex,
  Text,
  VStack,
  HStack,
  Avatar,
  useTheme,
  useColorMode,
  Button,
  Link,
  Spinner,
  useBreakpointValue,
  useColorModeValue,
  Spacer,
  Icon, 
  MenuButton, 
  IconButton, 
  Menu, 
  MenuList, 
  MenuGroup,
  useToast,
} from "@chakra-ui/react";
import { useAppContext } from "../../AppContext";
import debounce from "lodash.debounce";
import AsyncSelect from "react-select/async";
import { components } from "react-select";
import { RiSparkling2Fill, RiArrowUpLine, RiAddFill } from "react-icons/ri";
import {AddIcon} from "@chakra-ui/icons";
import {formatPhoneNumber} from "../../lib/PhoneNumbers";

function Inbox() {
  const { threads, setThreads, realtime, realtimeInitialized, filter, setFilter } = useAppContext();
  const navigate = useNavigate();
  const prevFilter = useRef(filter);
  const filterRef = useRef(filter);
  const [page, setPage] = useState({
    Open: 0,
    Unanswered: 0,
    Answered: 0,
    All: 0
  });
  const pageRef = useRef(page);
  const [loading, setLoading] = useState(false); // State to track loading status

  const [groupedByReplyStatusFilter, setGroupedByReplyStatusFilter] = useState(getIfGroupedByReplyStatus() && filter === "Open" ? "unanswered" : "answered");

  const getFilteredBy = () => {
    return  window.location.pathname === '/inbox' && filterRef.current === 'Open' && getIfGroupedByReplyStatus() && groupedByReplyStatusFilter && `&filter=${groupedByReplyStatusFilter}` || ""
  }

  const fetchThreads = async (force) => {
    if ((threads[`/${window.location.pathname.split('/')[1]}${filterRef.current}`] || []).length && !force) {
      return;
    }

    setLoading(true); // Set loading state to true
    const allThreads = [];
    const path = window.location.pathname.split('/')[1]
    for (let i = 0; i <= pageRef.current[filterRef.current]; i++) {
      const response = await cqAPI.get(
        `/threads?bids=${getBid()}&openonly=${filterRef.current === 'Open' ? 1 : 0}${getFilteredBy()}&page=${i}&type=${path === 'inbox' ? 'email,sms,emailsms,voicemail,api' : path === 'tasks'? 'task,appointment' : 'intercom'}`
      );
      allThreads.push.apply(allThreads, response.data.filter(thread => !allThreads.find(t => t._id === thread._id)))
    }
    if (!_.isEqual(threads[`/${window.location.pathname.split('/')[1]}${filterRef.current}`], allThreads)) {
      setThreads({
        ...threads,
        [`/${window.location.pathname.split('/')[1]}${filterRef.current}`]: allThreads
      });
    }
    setLoading(false); // Set loading state to false after threads are loaded
  };

  const fetchNextPageThread = async () => {
    setLoading(true); // Set loading state to true
    const path = window.location.pathname.split('/')[1]
    const response = await cqAPI.get(
      `/threads?bids=${getBid()}&filter=${filter}&page=${page[filter]}${getFilteredBy()}&type=${path === 'inbox' ? 'email,sms,emailsms,voicemail,api' : path === 'tasks'? 'task,appointment' : 'intercom'}`
    );
    if (response.data && response.data.length > 0) {
      setThreads({
        ...threads,
        [`/${path}${filterRef.current}`]: [
          ...(threads[`/${path}${filterRef.current}`] || []),
          ...response.data.filter(_thread => !([`/${path}${filterRef.current}`] || []).find(t => t._id === _thread._id)),
        ],
      });
    }
    setLoading(false); // Set loading state to false after the next page is loaded
  }

  const theme = useTheme();
  const location = useLocation();
  const { colorMode } = useColorMode();
  const hoverBgColor =
    colorMode === "light" ? theme.colors.gray[50] : theme.colors.gray[700];
  const bgColor = colorMode === "light" ? theme.colors.lightBackground : theme.colors.darkBackground;
  const borderColor = colorMode === "light" ? theme.colors.gray[200] : theme.colors.gray[700];
  const textColor = colorMode === "light" ? theme.colors.lightText : theme.colors.darkText;
  const secondaryTextColor = colorMode === "light" ? theme.colors.gray[600] : theme.colors.gray[400];
  const buttonBgColor = colorMode === "light" ? theme.colors.gray[200] : theme.colors.gray[700];
  const buttonSelectedColor = colorMode === "light" ? theme.colors.brand[900] : theme.colors.brand[50];
  const searchBgColor = colorMode === "light" ? "#f0f4f8" : "#2d3748";
  const mobileMarginLeft = useBreakpointValue({ base: "20px", md: "0" });
  const searchHoverBgColor = useColorModeValue(theme.colors.gray[200], theme.colors.gray[700])
  const searchResultBgColor = useColorModeValue(theme.colors.lightBackground, "#0f1a25")
  const searchRef = useRef(null)
  const [profiles, setprofiles] = useState([]);
  const [inboxSearchSelection, setInboxSearchSelection] = useState(null);
  const toast = useToast();

  useEffect(() => {
    if (!['/intercom', '/team'].includes(location.pathname)) {
      return;
    }

    const getAllProfiles = async () => {
      const res = await loadProfiles();
      const sorted = res.sort((a, b) => {
        return a.online && !b.online ? -1 : !a.online && b.online ? 1 :
          a.profile_name && !a.name && b.name && b.profile_name ? 1 : b.profile_name && !b.name && a.name && a.profile_name ? -1 :
            (a.name || '').toLowerCase() < (b.name || '').toLowerCase() ? -1 : 0;
      })
      setprofiles(sorted);
    }
    getAllProfiles();

  }, [location.pathname]);

  useEffect(() => {
    if (prevFilter.current !== filter) {
      filterRef.current = filter;
      fetchThreads(true);
      prevFilter.current = filter;
    } else {

      if (getIfGroupedByReplyStatus() && filter === "Open" && !groupedByReplyStatusFilter) {
        setGroupedByReplyStatusFilter("unanswered");
      }
      fetchThreads(true);
    }
  }, [location.pathname, filter, groupedByReplyStatusFilter]);

  useEffect(() => {
    pageRef.current = page;
    if (page[filter] > 0) {
      fetchNextPageThread();
    }
  }, [page]);

  useEffect(() => {
    if (!realtime.current) {
      return;
    }
    realtime.current.subscribeToTopic('uc_badge_update', getBid(), fetchThreads);
  }, [realtimeInitialized, realtime]);

  useEffect(() => {
    const current = realtime?.current;
    return () => {
      if (!current) {
        return;
      }
      current.unsubscribeFromTopic('uc_badge_update', getBid(), fetchThreads);
    };
  }, [location, realtime]);

  const truncateString = (str, num) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("");
  };
  
  const isPhoneNumber = (query) => {
    return /^\+?1?\d{10}$/.test(query || '');
  }

  const _loadSuggestions = (query, callback) => {
    const isPhoneSearch = isPhoneNumber(query);
    loadPatients(query, true).then(results => {
      if (isPhoneSearch && Array.isArray(results) && results.length === 0) {
        callback([{label: formatPhoneNumber(query), phone: query, isPhoneNumberOnly: true, notFound: true}]);
      } else {
        callback(results);
      }
    })
  };

  const _loadProfilesSuggestions = (query, callback) => {
    loadProfiles(query).then(callback);
  };

  const navigateToUid = async uid => {
    const newSearchParams = new URLSearchParams(
      window.location.search
    );
    if (uid.includes(':')) {
      uid = await getUserForPatient(uid.split(':')[0], uid.split(':')[1]);
    }
    navigate(`${window.location.pathname}/${uid}?${newSearchParams.toString()}`);
  };

  const debouncedLoadPatients = debounce(_loadSuggestions, 1000);
  const debouncedLoadProfiles = debounce(_loadProfilesSuggestions, 1000);

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <FontAwesomeIcon icon={faSearch} />
        </components.DropdownIndicator>
      )
    );
  };

  const customStyles = ({
    width,
    height,
    paddingTop = 0,
    paddingBottom = 0,
    paddingLeft = 16,
    paddingRight = 16,
  }) => ({
    container: (provided) => ({
      ...provided,
      width: `${width}`,
      marginLeft: mobileMarginLeft,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? searchHoverBgColor   // Dynamic color when option is focused
        : searchResultBgColor, // Dynamic default option background color
    }),
    control: (provided) => ({
      ...provided,
      minHeight: `${height}px`,
      height: `${height}px`,
      justifyContent: "flex-start",
      padding: 0,
      boxShadow: "none",
      borderRadius: "140px", // Rounded corners
      backgroundColor: searchBgColor, // Dynamic background color
      border: "none", // No border
    }),
    menu: (provided) => ({
      ...provided,
      width: "100%", // Adjust to full width
      marginTop: "0",
      marginBottom: "0",
      position: "absolute",
      left: "0", // Align to the left
      backgroundColor: bgColor, // Dynamic menu background color
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: `${height}`,
      padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
    }),
    placeholder: (provided) => ({
      ...provided,
      textAlign: "left",
      color: secondaryTextColor, // Dynamic placeholder text color
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      height: `${height - paddingTop - paddingBottom}px`,
      color: textColor, // Dynamic input text color
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: `${height}`,
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "5px",
    }),
  });

  const CustomOption = (props) => {
    const addPhoneNumber = async () => {
      console.log('Creating', props.data.label);
      cqAPI.post(
        '/add-phone-number-contact', {
        phone: props.data.phone
      }).then(r => {
        console.log("Received response", JSON.stringify(r, null, 2));
        if (r.type === 'ok') {
          navigateToUid(r?.user?.id);
        } else {
          toast({
            title: "Error adding number contact.",
            description: r.msg || 'Cannot save contact',
            status: "error",
            duration: 9000,
            isClosable: true,
          });  
        }
      }).catch(err => {
        toast({
          title: "Error adding number contact.",
          description: err.msg,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      });
    };
    
    return (
      <components.Option {...props}>
        {(!props.data.isPhoneNumberOnly && !props.data.notFound) && <div className="custom-option">
          <div className="custom-option-details">
            <div className="custom-option-name">{props.data.label}</div>
            <div className="custom-option-email">{props.data.email}</div>
            {props.data.dob && <div className="custom-option-email">DoB: {moment(props.data.dob).calendar()}</div>}
          </div>
          <FontAwesomeIcon
            icon={faChevronRight}
            className="custom-option-arrow"
          />
        </div>}
        {(props.data.isPhoneNumberOnly && props.data.notFound) && <div className="custom-option">
          <div className="custom-option-details">
            <div className="custom-option-name">{props.data.label}</div>
          </div>
          <Button
            minWidth="150px"
            leftIcon={<AddIcon />}
            onClick={addPhoneNumber}
          >
            Add Number
          </Button>
        </div>}
      </components.Option>
    );
  };

  const CustomProfileOption = (props) => {
    return (
      <components.Option {...props}>
        <div className="custom-option">
          <Box
            mr={4}
            bg={props.data.online ? 'green' : "grey"}
            w="10px"
            h="10px"
            borderRadius="full"
            display="inline-block"
          />
          <Avatar mr={4} name={(props.data.name || '').replace(/[^a-zA-Z ]/g, '').trim() || 'U N'} size="md"
                  bg={theme.colors.secondary[200]} color={theme.colors.darkText}/>
          <div className="custom-option-details">
            <div className="custom-option-name">{props.data.name}</div>
            {props.data.name !== props.data.profile_name && <div className="custom-option-email">{props.data.profile_name || ''}</div>}
          </div>
          <Spacer/>
          <FontAwesomeIcon
            icon={faChevronRight}
            className="custom-option-arrow"
          />
        </div>
      </components.Option>
    );
  }

  const handleSelectChange = async (selectedOption) => {
    let uid = selectedOption._id;
    if (!uid) {
      setInboxSearchSelection(null);
      return;
    }
    setInboxSearchSelection(selectedOption);
    await navigateToUid(uid);
  };

  const handleProfileSelectChange = async (selectedOption) => {
    const newSearchParams = new URLSearchParams(
      window.location.search
    );
    let uid = selectedOption.provider_id || selectedOption.id;
    if (!uid) {
      uid = await getProviderForProfile(selectedOption.adec_id);
      if (!uid){
        return
      }
    }
    navigate(`${window.location.pathname}/${uid}?${newSearchParams.toString()}`);
  };

  const toggleFilter = (newFilter) => {
    if (newFilter === "answered" || newFilter === "unanswered" ) {
      setFilter("Open");
      filterRef.current = "Open";
      return setGroupedByReplyStatusFilter(newFilter);
    }
    setFilter(newFilter);
  };

  const handleLoadMore = () => {
    setPage({
      ...page,
      [filter]: page[filter] + 1
    });
  }

  return (
    <Box overflowY="auto" maxHeight="100vh" width="100%">
      <Box p={4} width="90%">
        {window.location.pathname === '/inbox' && (
          <Box mb={4} width="100%">
            <AsyncSelect
              id={"search-patient-inbox"}
              key={"select-search-patient-inbox"}
              loadOptions={debouncedLoadPatients}
              placeholder="Search Patient Conversations"
              components={{ DropdownIndicator, Option: CustomOption }}
              className="search-input"
              styles={customStyles({ width: '100%', height: 48 })}
              value={inboxSearchSelection}
              onChange={handleSelectChange}
            />
          </Box>
        )}
        {['/intercom','/team'].includes(window.location.pathname) && (
          <Flex direction="row" align={"center"} mb={4} width="100%">
            <Box mr={2} width="100%">
              <AsyncSelect
                ref={searchRef}
                loadOptions={debouncedLoadProfiles}
                placeholder={window.location.pathname === '/intercom'? "Search Profiles" : "Search Team"}
                components={{ DropdownIndicator, Option: CustomProfileOption }}
                className="search-input"
                styles={customStyles({ width: '100%', height: 48 })}
                onChange={handleProfileSelectChange}
              />
            </Box>
            <Menu>
              <MenuButton
                as={IconButton}
                aria-label="add recipient"
                icon={<RiAddFill/>}
                boxSize={10}
                fontSize="xl"
                styles={customStyles({ width: '100%', height: 48 })}
              />
              <MenuList minW="300px" p={2} maxH="600px" overflowY="auto">
                <MenuGroup title="Recipients" fontSize="sm" fontWeight="bold" px={3} pt={2}>
                  {profiles.length > 0 && profiles.map((r) => (
                    <Box
                      key={r.adec_id}
                      onClick={() => handleProfileSelectChange(r)}
                      _hover={{ bg: theme.colors.gray[50] }}
                      cursor="pointer"
                      mx={0}
                      px={3}
                      py={2}
                    >
                      <CustomProfileOption
                        data={r}
                        selectProps={{}}
                        getStyles={() => ({})}
                        getClassNames={() => ({})}
                        cx={() => ""}
                        isFocused={false}
                        isSelected={false}
                        innerProps={{}}
                      />
                    </Box>
                  ))}
                </MenuGroup>
              </MenuList>

            </Menu>
          </Flex>
        )}
        <HStack spacing={0} justifyContent="left" mb={4} flexWrap="wrap" ml={mobileMarginLeft}>
          {
            window.location.pathname === '/inbox' && getIfGroupedByReplyStatus() ?
              <>
                <Button
                  onClick={() => toggleFilter("unanswered")}
                  bg={filter === "Open" && groupedByReplyStatusFilter === "unanswered" ? buttonSelectedColor : buttonBgColor}
                  color={filter === "Open" && groupedByReplyStatusFilter === "unanswered" ? bgColor : textColor}
                  _hover={{ bg: buttonSelectedColor }}
                  borderRadius="16px 0 0 16px"
                  borderRight="1px solid"
                  borderColor={borderColor}
                  height="44px"
                  width="120px"
                >
                  Unanswered
                </Button>
                <Button
                  onClick={() => toggleFilter("answered")}
                  bg={filter === "Open" && groupedByReplyStatusFilter === "answered" ? buttonSelectedColor : buttonBgColor}
                  color={filter === "Open" && groupedByReplyStatusFilter === "answered" ? bgColor : textColor}
                  _hover={{ bg: buttonSelectedColor }}
                  borderRadius="0 0 0 0"
                  borderRight="1px solid"
                  borderColor={borderColor}
                  height="44px"
                  width="100px"
                >
                  Answered
                </Button>
              </>
              :
              <Button
                onClick={() => toggleFilter("Open")}
                bg={filter === "Open" ? buttonSelectedColor : buttonBgColor}
                color={filter === "Open" ? bgColor : textColor}
                _hover={{ bg: buttonSelectedColor }}
                borderRadius="16px 0 0 16px"
                borderRight="1px solid"
                borderColor={borderColor}
                height="44px"
                width="69px"
              >
                Open
              </Button>
          }
          <Button
            onClick={() => toggleFilter("All")}
            bg={filter === "All" ? buttonSelectedColor : buttonBgColor}
            color={filter === "All" ? bgColor : textColor}
            _hover={{ bg: buttonSelectedColor }}
            borderRadius="0 16px 16px 0"
            height="44px"
            width="69px"
          >
            All
          </Button>
        </HStack>
      </Box>
      <Box p={4} width="100%">
        <VStack spacing={0} align="stretch" className="messageContainer">
          {(threads[window.location.pathname + `${filterRef.current}`] || []).length > 0 ?
            (threads[window.location.pathname + `${filterRef.current}`] || []).map((thread, index) => {
            const isAva = thread.from === "000000000000000000000000";
            return (<Flex
                key={thread._id || index}
                p={4}
                borderBottom="1px"
                borderColor={borderColor}
                className="thread"
                _hover={{ bg: hoverBgColor, cursor: "pointer" }}
                onClick={async () => {
                  const newSearchParams = new URLSearchParams(
                    window.location.search
                  );
                  newSearchParams.set("bid", thread.bid);
                  navigate(`${window.location.pathname}/${thread.from}?${newSearchParams.toString()}`);
                }}
                align="center"
                w="full"
              >
                <Box mr={4}>
                    <Avatar size="md"
                            name={isAva? undefined : (thread.subject || '').replace(/[^a-zA-Z ]/g, '').trim() || 'U N'}
                            bg={theme.colors.secondary[200]}
                            color={theme.colors.darkText}
                            icon={isAva ? <Icon as={RiSparkling2Fill} boxSize={9} />: undefined}
                    />
                </Box>
                <VStack align="start" spacing={1} flex="1" w="full">
                  <Text className="responsive-text" fontWeight="bold" color={textColor} textAlign="left" id={`thread-name-${thread._id}`}
                        fontSize={{ base: "sm", md: "md", lg: "lg" }}>
                    {thread.subject}
                  </Text>
                  <Box
                    dangerouslySetInnerHTML={{
                      __html: truncateString(thread.body, 100),
                    }}
                    style={{ textAlign: "left", color: secondaryTextColor }}
                  ></Box>
                </VStack>
                <Text className='date' fontSize="xs" color={secondaryTextColor} align="right">
                  {moment(thread.updated).format("MMM D, YYYY h:mm a")}
                </Text>
              </Flex>
            )
          }) : ['/intercom','/team'].includes(window.location.pathname) && (
            <Flex
              p={4}
              borderColor={borderColor}
              className="thread"
              _hover={{ bg: hoverBgColor, cursor: "pointer" }}
              onClick={() => {
                searchRef.current?.focus();
              }}
              align="center"
              w="full"
            >
              <Box mr={4}>
                <Avatar size="md"
                        bg={theme.colors.secondary[200]}
                        color={theme.colors.darkText}
                        icon={<Icon as={RiArrowUpLine} boxSize={9} />}
                />
              </Box>
              <VStack align="start" spacing={1} flex="1" w="full">
                <Text className="responsive-text" fontWeight="bold" color={textColor} textAlign="left"
                      fontSize={{ base: "sm", md: "md", lg: "lg" }}>
                  Search above to get started
                </Text>
              </VStack>
            </Flex>
          )}
        </VStack>
      </Box>
      {threads[window.location.pathname+`${filterRef.current}`] && threads[window.location.pathname+`${filterRef.current}`].length > 0 && (
        <Link
          onClick={handleLoadMore}
          marginTop="20px"
        >
          {loading ? <Spinner size="sm" /> : "Load More"}
        </Link>
      )}
    </Box>
  );
}

export default Inbox;
